module.exports = __webpack_public_path__ + "img/youtube.04d8390f.svg";